export const GET_HOLDCO_LIST_REQUEST = 'GET_HOLDCO_LIST_REQUEST';
export const GET_HOLDCO_LIST_SUCCESS = 'GET_HOLDCO_LIST_SUCCESS';
export const GET_HOLDCO_LIST_FAILURE = 'GET_HOLDCO_LIST_FAILURE';

// For get by id (edit)
export const GET_HOLDCO_BY_ID_REQUEST = 'GET_HOLDCO_BY_ID_REQUEST';
export const GET_HOLDCO_BY_ID_SUCCESS = 'GET_HOLDCO_BY_ID_SUCCESS';
export const GET_HOLDCO_BY_ID_FAILURE = 'GET_HOLDCO_BY_ID_FAILURE';

// For delete
export const DELETE_HOLDCO_REQUEST = 'DELETE_HOLDCO_REQUEST';
export const DELETE_HOLDCO_SUCCESS = 'DELETE_HOLDCO_SUCCESS';
export const DELETE_HOLDCO_FAILURE = 'DELETE_HOLDCO_FAILURE';
export const RESET_DELETE_STATE = 'RESET_DELETE_STATE';

// For delete file
export const DELETE_HOLDCO_FILE_REQUEST = 'DELETE_HOLDCO_FILE_REQUEST';
export const DELETE_HOLDCO_FILE_SUCCESS = 'DELETE_HOLDCO_FILE_SUCCESS';
export const DELETE_HOLDCO_FILE_FAILURE = 'DELETE_HOLDCO_FILE_FAILURE';

// For save
export const SAVE_HOLDCO_REQUEST = 'SAVE_HOLDCO_REQUEST';
export const SAVE_HOLDCO_SUCCESS = 'SAVE_HOLDCO_SUCCESS';
export const SAVE_HOLDCO_FAILURE = 'SAVE_HOLDCO_FAILURE';
export const RESET_SAVE_STATE = 'RESET_SAVE_STATE';
